/* ============
 * Main File
 * ============
 *
 * Will initialize the application
 */
import Vue from "vue";
import * as App from "./app";
import VueTouch from "vue2-touch-events";
import './tailwind.css';


Vue.use(VueTouch, {
  tapTolerance: 50,
});

require("../static/material/global/css/annual_calendar_2.css");
require("../static/material/global/css/bundle.css");
require("../static/material/global/css/analytics.css");

// require('../static/material/global/css/font-awesome.min.css');
// require('../static/material/global/css/bootstrap.min.css');
// require('../static/material/global/css/bootstrap-extend.min.css');
require("../static/material/global/fonts_b/web-icons/web-icons.min.css");
// require('../static/material/iconbar/assets/css/site.min.css');

// require('../static/material/global/vendor/animsition/animsition.css');
// require('../static/material/global/vendor/asscrollable/asScrollable.css');
// require('../static/material/global/vendor/switchery/switchery.css');
// require('../static/material/global/vendor/intro-js/introjs.css');
// require('../static/material/global/vendor/slidepanel/slidePanel.css');
// require('../static/material/global/vendor/flag-icon-css/flag-icon.css');
// require('../static/material/global/vendor/waves/waves.css');
// require('../static/material/global/vendor/jquery-labelauty/jquery-labelauty.css');
// require('../static/material/global/vendor/dropify/dropify.css');
// require('../static/material/global/css/bootstrap-select.min.css');

require("../static/material/iconbar/assets/examples/css/pages/login-v2.css");
require("../static/material/iconbar/assets/examples/css/pages/register-v2.css");
require("../static/material/iconbar/assets/examples/css/pages/forgot-password.css");

require("../static/material/global/vendor/toastr/toastr.css");
require("../static/material/global/vendor/redactor/redactor.min.css");
require("../static/material/global/vendor/c3/c3.min.css");
require("../static/material/global/vendor/webui-popover/webui-popover.min.css");

// require('../static/material/global/vendor/babel-external-helpers/babel-external-helpers.js');
// require('../static/material/global/vendor/jquery/jquery.js');
// require('../static/material/global/js/jquery-ui.min.js');
// require('../static/material/global/vendor/tether/tether.js');
// require('../static/material/global/vendor/bootstrap/bootstrap.js');
require("../static/material/global/vendor/animsition/animsition.js");
require("../static/material/global/vendor/mousewheel/jquery.mousewheel.js");
require("../static/material/global/vendor/asscrollbar/jquery-asScrollbar.js");
require("../static/material/global/vendor/asscrollable/jquery-asScrollable.js");
// require('../static/material/global/vendor/ashoverscroll/jquery-asHoverScroll.js');
require("../static/material/global/vendor/waves/waves.js");

require("../static/material/global/vendor/switchery/switchery.min.js");
require("../static/material/global/vendor/intro-js/intro.js");
require("../static/material/global/vendor/screenfull/screenfull.js");
require("../static/material/global/vendor/slidepanel/jquery-slidePanel.js");
require("../static/material/global/vendor/jquery-placeholder/jquery.placeholder.js");
require("../static/material/global/vendor/jquery-labelauty/jquery-labelauty.js");
require("../static/material/global/vendor/dropify/dropify.min.js");

// require('../static/material/global/js/State.js');
// require('../static/material/global/js/Component.js');
// require('../static/material/global/js/Plugin.js');
// require('../static/material/global/js/Base.js');
// require('../static/material/global/js/Config.js');
// require('../static/material/iconbar/assets/js/Section/Menubar.js');
// require('../static/material/iconbar/assets/js/Section/Sidebar.js');
// require('../static/material/iconbar/assets/js/Section/PageAside.js');
// require('../static/material/iconbar/assets/js/Plugin/menu.js');

// require('../static/material/global/js/config/colors.js');
// require('../static/material/iconbar/assets/js/config/tour.js');

// require('../static/material/iconbar/assets/js/Site.js');
// require('../static/material/global/js/Plugin/asscrollable.js');
// require('../static/material/global/js/Plugin/slidepanel.js');
// require('../static/material/global/js/Plugin/switchery.js');
// require('../static/material/global/js/Plugin/jquery-placeholder.js');
// require('../static/material/global/js/Plugin/material.js');
require("../static/material/global/js/bootstrap-select.min.js");
// require('../static/material/global/vendor/toastr/toastr.min.js');
// require('../static/material/global/vendor/clipboard.js-master/src/clipboard.min');
require("../static/material/global/js/line-chart.js");
// require('../static/material/global/vendor/webui-popover/jquery.webui-popover.min.js');

require("../static/material/global/js/custom.js");

new Vue(App).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js